import { render, staticRenderFns } from "./index.vue?vue&type=template&id=21919359&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21919359",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2023/thShop/thShopAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21919359')) {
      api.createRecord('21919359', component.options)
    } else {
      api.reload('21919359', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=21919359&scoped=true&", function () {
      api.rerender('21919359', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/finance/bank/index.vue"
export default component.exports